import React, { ChangeEvent, useContext } from "react";
import { computed } from "mobx";
import { observer } from "mobx-react";

import { ResultsMenuTournament } from "@data-types/results";
import {
	ResultsMenuCategoryContext,
	ResultsMenuStoreContext,
} from "@state/context/results";
import classnames from "classnames";

import { Checkbox } from "@components/inputs/shared";
import ResultsTournamentIcon from "./ResultsTournamentIcon";

export default observer(function ResultsTournamentsItem({
	tournament,
}: {
	tournament: ResultsMenuTournament;
}) {
	const store = useContext(ResultsMenuStoreContext);
	const category = useContext(ResultsMenuCategoryContext);

	const isSelected = computed(() =>
		store.isTournamentSelected(tournament.id)
	).get();
	const labelId = `sport-${tournament.sportId}-category-${tournament.categoryId}-tournament-${tournament.id}`;

	return (
		<li className="nav--quaternary__item">
			<div
				className={classnames("nav--quaternary__link", {
					"is-active": isSelected,
				})}
			>
				<span className="input--check input--check--sml nav--quaternary__check">
					<Checkbox
						id={labelId}
						className={`at--${tournament.abrv} input--check__box input--check--sml__box nav--quaternary__box`}
						name={tournament.name}
						title={tournament.name}
						checked={isSelected}
						onChange={(e: ChangeEvent<HTMLInputElement>) => {
							e.stopPropagation();
							const isUpdated =
								store.toggleTournament(tournament);
							if (!isUpdated) {
								e.target.checked = !e.target.checked;
							}
						}}
					/>
					<label
						htmlFor={labelId}
						className="input--check__label input--check--sml__label nav--quaternary__label"
					>
						<ResultsTournamentIcon
							sport={store.selectedSportObj!.abrv}
							category={category.abrv}
							tournament={tournament.abrv}
						/>
						<span>{tournament.name}</span>
					</label>
				</span>

				<span className="nav--quaternary__counter counter counter--base">
					{tournament.count}
				</span>
			</div>
		</li>
	);
});
